import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetInlineEditEventInfoQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetInlineEditEventInfoQuery = {
  __typename?: 'Query';
  eventByName?: { __typename?: 'Event'; id: string; info: { __typename?: 'EventInfo'; id: string; eventPassword?: string | null } } | null;
};

export type GetPagePhotoInfoQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
  type?: Types.InputMaybe<Types.EventPageType>;
  eventDesignPurpose?: Types.InputMaybe<Types.EventDesignPurpose>;
}>;

export type GetPagePhotoInfoQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    pagesInfo?: Array<{
      __typename?: 'EventPageInfo';
      id: string;
      page: {
        __typename?: 'EventPage';
        id: string;
        type: Types.EventPageType;
        pageSlug: string;
        photoV2?:
          | {
              __typename?: 'DefaultPagePhoto';
              id: string;
              url: string;
              width: number;
              height: number;
              layout: { __typename?: 'DefaultPagePhotoLayout'; alignX: string; alignY: string };
            }
          | { __typename?: 'Photo'; id: string; url: string; width: number; height: number; layout: { __typename?: 'PhotoLayout'; alignX: string; alignY: string } }
          | null;
        photoPresentation?: {
          __typename?: 'WebsitePagePhotoPresentation';
          id: string;
          presentationLayout: string;
          cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo'; x: number; y: number; width: number; height: number; unit: string } | null;
        } | null;
      };
    }> | null;
    eventDesign?: { __typename?: 'EventDesign'; id: string; websiteLayout: { __typename?: 'DesignLayout'; id: string; layoutType: Types.DesignLayoutType } } | null;
  } | null;
};

export const GetInlineEditEventInfoDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetInlineEditEventInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventPassword' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetInlineEditEventInfoQuery__
 *
 * To run a query within a React component, call `useGetInlineEditEventInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInlineEditEventInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInlineEditEventInfoQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetInlineEditEventInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInlineEditEventInfoQuery, GetInlineEditEventInfoQueryVariables>) {
  return ApolloReactHooks.useQuery<GetInlineEditEventInfoQuery, GetInlineEditEventInfoQueryVariables>(GetInlineEditEventInfoDocument, baseOptions);
}
export function useGetInlineEditEventInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInlineEditEventInfoQuery, GetInlineEditEventInfoQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetInlineEditEventInfoQuery, GetInlineEditEventInfoQueryVariables>(GetInlineEditEventInfoDocument, baseOptions);
}
export type GetInlineEditEventInfoQueryHookResult = ReturnType<typeof useGetInlineEditEventInfoQuery>;
export type GetInlineEditEventInfoLazyQueryHookResult = ReturnType<typeof useGetInlineEditEventInfoLazyQuery>;
export type GetInlineEditEventInfoQueryResult = Apollo.QueryResult<GetInlineEditEventInfoQuery, GetInlineEditEventInfoQueryVariables>;
export const GetPagePhotoInfoDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPagePhotoInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventPageType' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventDesignPurpose' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPurpose' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagesInfo' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'type' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'page' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageSlug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photoV2' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'layout' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DefaultPagePhoto' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'layout' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photoPresentation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'presentationLayout' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cropInfo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventDesign' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'purpose' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventDesignPurpose' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'websiteLayout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'layoutType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetPagePhotoInfoQuery__
 *
 * To run a query within a React component, call `useGetPagePhotoInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPagePhotoInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPagePhotoInfoQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      type: // value for 'type'
 *      eventDesignPurpose: // value for 'eventDesignPurpose'
 *   },
 * });
 */
export function useGetPagePhotoInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPagePhotoInfoQuery, GetPagePhotoInfoQueryVariables>) {
  return ApolloReactHooks.useQuery<GetPagePhotoInfoQuery, GetPagePhotoInfoQueryVariables>(GetPagePhotoInfoDocument, baseOptions);
}
export function useGetPagePhotoInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPagePhotoInfoQuery, GetPagePhotoInfoQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetPagePhotoInfoQuery, GetPagePhotoInfoQueryVariables>(GetPagePhotoInfoDocument, baseOptions);
}
export type GetPagePhotoInfoQueryHookResult = ReturnType<typeof useGetPagePhotoInfoQuery>;
export type GetPagePhotoInfoLazyQueryHookResult = ReturnType<typeof useGetPagePhotoInfoLazyQuery>;
export type GetPagePhotoInfoQueryResult = Apollo.QueryResult<GetPagePhotoInfoQuery, GetPagePhotoInfoQueryVariables>;
